import './application';
import '../apps/explore_v2/main.ts';
import '../apps/on_boarding/main.ts';
import '../apps/flyover_preview/main.ts';

console.log("Hello from the Hiiker Explorer! 🌍");
